export default "/_next/static/images/d6b4766810599310d138ac66f17e8f9f.jpg";